import { Building2, Sofa, Hammer, PencilRuler, Home, Wrench, Boxes, Layers } from "lucide-react";

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Portfolio", to: "/portfolio" },
  { label: "Calculator", to: "/calculator" },
  { label: "Careers", to: "/careers" },
  { label: "Brochure", to: "/brochure" },
  { label: "Contact", to: "/contact" },
];

export const DIVISION_LINKS = [
  { label: "UYI Construction", to: "/divisions/construction" },
  { label: "UYI Interior", to: "/divisions/interior" },
  { label: "UYI Furniture", to: "/divisions/furniture" },
];

export const MANIFESTO = [
  {
    no: "01",
    title: "The Foundation",
    body: "Every legacy begins with a solid base. We engineer structures that stand the test of time — precise, resilient and built to exacting standards.",
  },
  {
    no: "02",
    title: "The Vision",
    body: "Architecture is intention made visible. Our 2D & 3D design studio translates aspiration into blueprints that balance beauty and function.",
  },
  {
    no: "03",
    title: "The Craft",
    body: "From raw concrete to bespoke furniture, our artisans obsess over the details that transform a house into a home.",
  },
  {
    no: "04",
    title: "The Legacy",
    body: "With 25+ years across Lucknow & Uttar Pradesh, we deliver spaces families are proud to inherit for generations.",
  },
];

export const SERVICES = [
  { icon: Building2, title: "Residential Construction", desc: "Turnkey homes and villas built with structural precision and premium finishes." },
  { icon: Layers, title: "Commercial Projects", desc: "Offices, retail and commercial buildings engineered for performance and ROI." },
  { icon: PencilRuler, title: "2D & 3D Design", desc: "Photoreal visualisation and architectural planning before a single brick is laid." },
  { icon: Sofa, title: "Interior Design", desc: "Bespoke interiors that balance luxury, comfort and everyday liveability." },
  { icon: Wrench, title: "Renovation", desc: "Breathing new life into existing spaces with modern, durable upgrades." },
  { icon: Boxes, title: "Custom Furniture", desc: "Handcrafted, made-to-measure furniture designed for your exact space." },
];

export const VALUES = [
  { title: "Quality", body: "Uncompromising materials and workmanship on every project." },
  { title: "Precision", body: "Delivered on brief, on budget and on time." },
  { title: "Commitment", body: "A relationship that lasts long after handover." },
];

export const DIVISIONS = {
  construction: {
    key: "construction",
    name: "UYI Construction",
    icon: Building2,
    tagline: "Strong homes don't happen by chance — they're built.",
    hero: "https://images.unsplash.com/photo-1709496709586-ad1467b5d738?crop=entropy&cs=srgb&fm=jpg&q=85",
    intro:
      "From foundation to finish, UYI Construction delivers residential and commercial projects across Lucknow and Uttar Pradesh with engineering-grade precision.",
    offerings: [
      "Residential villas & independent houses",
      "Commercial & retail buildings",
      "Slab casting & structural RCC work",
      "Brickwork, plastering & waterproofing",
      "Turnkey project management",
      "Site supervision & quality control",
    ],
    gallery: [
      "https://images.unsplash.com/photo-1709496709586-ad1467b5d738?crop=entropy&cs=srgb&fm=jpg&q=85",
      "https://images.unsplash.com/photo-1701850009190-2859ba2aeea6?crop=entropy&cs=srgb&fm=jpg&q=85",
      "https://images.unsplash.com/photo-1761479135364-4240520b5793?crop=entropy&cs=srgb&fm=jpg&q=85",
    ],
  },
  interior: {
    key: "interior",
    name: "UYI Interior",
    icon: Sofa,
    tagline: "Give your dream home a modern, beautiful look.",
    hero: "https://images.pexels.com/photos/20418771/pexels-photo-20418771.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    intro:
      "Our interior studio composes light, texture and material into spaces that feel effortless and unmistakably luxurious.",
    offerings: [
      "Full home & apartment interiors",
      "Modular kitchens & wardrobes",
      "False ceiling & lighting design",
      "Living, dining & bedroom styling",
      "Commercial & office interiors",
      "3D interior visualisation",
    ],
    gallery: [
      "https://images.pexels.com/photos/20418771/pexels-photo-20418771.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      "https://images.pexels.com/photos/34688219/pexels-photo-34688219.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      "https://images.unsplash.com/photo-1594580701468-e5678582b8ce",
    ],
  },
  furniture: {
    key: "furniture",
    name: "UYI Furniture",
    icon: Boxes,
    tagline: "Made-to-measure furniture, crafted for your space.",
    hero: "https://images.pexels.com/photos/8082229/pexels-photo-8082229.jpeg",
    intro:
      "Every piece is designed and built in-house — combining fine materials, precise joinery and a finish worthy of a flagship showroom.",
    offerings: [
      "Bespoke sofas & lounge suites",
      "Dining tables & seating",
      "Wardrobes & storage systems",
      "TV units & display consoles",
      "Office & workspace furniture",
      "Premium wood & upholstery finishes",
    ],
    gallery: [
      "https://images.pexels.com/photos/8082229/pexels-photo-8082229.jpeg",
      "https://images.pexels.com/photos/11262212/pexels-photo-11262212.jpeg",
      "https://images.pexels.com/photos/20035976/pexels-photo-20035976.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    ],
  },
};

export const ICONS = { Home, Hammer };
